<div class="activity-history" fxLayout="column" fxLayoutAlign="center center">
  @if (error) {
    <error-message
      [error]="error"
      [page]="'Activity History'">
    </error-message>
  }

  @if (!error && !isMobile) {
    <div class="activity-history__body">
      <data-table [totalElements]="allRecords.length"
        [frontEndPaging]="true"
        [columns]="columns"
        [rows]="allRecords"
        [isLoading]="loading"
        [noResultsMessage]="noResultsText"
        [numberOfPages]="getNumberOfPages(allRecords.length)"
        [pageSize]="pageSize"
        [noteProp]="noteProp"
        (onExternalLinkClick)="viewEmailDetails.emit($event)">
      </data-table>
    </div>
  }

  @if (isMobile) {
    <div class="activity-history__data-container">
      @if (loading) {
        <div
          class="activity-history__loading"
          [cfaLoading]="true">
        </div>
      }
      @if (!loading) {
        <div>
          @if (displayRecords.length === 0) {
            <div>{{noResultsText}}</div>
          }
          @for (action of displayRecords; track action.activityId ?? (action.updatedAt + '|' + action.updatedBy + '|' + $index); let i = $index) {
            <div
              class="activity-history__response-container"
              [ngClass]="{'activity-history__blue-row-background' : (i % 2  !== 0), 'activity-history__white-row-background' : (i % 2  === 0)}">
              <div [innerHTML]="action[statusVariable]" class="activity-history__status-text"></div>
              <div fxLayout="row" class="activity-history__row-container">
                <span fxFlex="40" class="activity-history__label">{{dateLabel}}:</span>
                <span fxFlex="60" class="activity-history__info">{{action.updatedAt | locTimeZoneDate:'ddd, MMM DD YYYY hh:mm A':true}}</span>
              </div>
              <div fxLayout="row" class="activity-history__row-container">
                <span fxFlex="40" class="activity-history__label">User:</span>
                @if (action.updatedBy) {
                  <span fxFlex="60" class="activity-history__info">{{action.updatedBy}}</span>
                }
                @if (!action.updatedBy) {
                  <span fxFlex="60" class="activity-history__info">N/A</span>
                }
              </div>
              <div fxLayout="row" class="activity-history__row-container">
                <span fxFlex="40" class="activity-history__label">Communication Sent:</span>
                @if (action.hasEmailRecord) {
                  <a
                    fxFlex="60"
                    (click)="viewEmailDetails.emit(action)"
                    class="activity-history__info activity-history__info-red">
                    View Email
                  </a>
                }
                @if (!action.hasEmailRecord) {
                  <span fxFlex="60" class="activity-history__info">N/A</span>
                }
              </div>
              <div fxLayout="row" class="activity-history__row-container">
                <span fxFlex="40" class="activity-history__label">Notes:</span>
                @if (action[noteProp] && action[noteProp].length > 0) {
                  <a
                    fxFlex="60"
                    (click)="action.isNoteOpen = !action.isNoteOpen"
                    class="activity-history__info activity-history__info-red">
                    {{getViewNotesLabel(action)}}
                  </a>
                }
                @if (!action[noteProp] || action[noteProp].length == 0) {
                  <span fxFlex="60" class="activity-history__info">N/A</span>
                }
              </div>
              @if (action.isNoteOpen) {
                <div fxLayout="row" class="activity-history__row-container">
                  @for (note of action[noteProp]; track note.id || note.noteId || (note.updatedAt + '|' + note.updatedBy + '|' + note.note + '|' + $index)) {
                    <div fxLayout="row"
                      fxFlex="100"
                      >
                      <div class="activity-history__note">
                        <div>
                          <span class="activity-history__note-name">{{note.updatedBy}}</span>
                          <span class="activity-history__note-date"> - {{note.updatedAt | locTimeZoneDate:'MMM DD, YYYY hh:mm A'}}</span>
                        </div>
                        <div class="activity-history__note-text">{{note.note}}</div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
          @if (allRecords.length) {
            <pagination
              [totalElements]="allRecords.length"
              [pageSize]="pageSize"
              [currentPage]="currentPage"
              (pageRight)="pageRight()"
              (pageLeft)="pageLeft()">
            </pagination>
          }
        </div>
      }
    </div>
  }
</div>
